export enum FormMode {
    CREATE,
    EDIT,
    VIEW
}
